import { render, staticRenderFns } from "./WorkLogsTable.vue?vue&type=template&id=18e1a313&scoped=true&"
import script from "./WorkLogsTable.vue?vue&type=script&lang=js&"
export * from "./WorkLogsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e1a313",
  null
  
)

export default component.exports